<template>
  <modal :modal-key="'open_box_modal'"
         @close="$emit('close')"
         class="modal--welcomeback no_space"
         :body-style="'achievement'">
    <template slot="header">
      <template v-if="!determineResult()">
          <h1>{{ getTranslations.home_modals_loot_box_congrats }}</h1>
        <h1>{{ getTranslations.home_modals_notifications_loot_box_unlocked }}</h1>
      </template>
      <template v-else-if="determineResult() && chestOpened">
        <h1>{{ getTranslations.home_modals_notifications_loot_box_yeah }}</h1>
        <h1>{{ getTranslations.home_modals_loot_box_win }} {{ getTranslations[prizeName] }}</h1>
      </template>
    </template>
    <template slot="body">
      <div class="open_box prize" v-if="!determineResult()">
        <div class="open_box_container">
          <img id="pic-click" v-if="!disableDuration" src="static/images/free_game_assets/chest_static.jpg">
          <img id="gif-click" v-else src="static/images/free_game_assets/chest_anim.gif">
        </div>
        <a href="#"
           v-if="!chestOpened"
           @click.prevent="open()"
           id="click"
           class="btn2 btn2_modal btn2--std btn2--small">
          {{ getTranslations.home_modals_achievements_reward_loot }}
        </a>
      </div>
      <div class="open_box prize" v-else-if="determineResult() && chestOpened">
        <div class="bounce_box bounce_animation">
          <img class="icon" src="static/images/bonus_points.svg" alt="">
        </div>
        <a href="#"
           @click.prevent="claimPrize()"
           class="btn2 btn2_modal btn2--std btn2--small">
          {{ getTranslations.home_modals_loot_box_claim_prize }}
        </a>
      </div>
      <span v-show="showResult && !determineResult() && chestOpened">
       {{ getTranslations.home_modals_loot_box_lost }}
      </span>
    </template>
  </modal>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import HowToGetPrize from '@/components/home/modals/achievements/HowToGetPrize';

export default {
  name: 'loot-box',
  components: {
    Modal,
  },
  emits: ['read'],
  watch: {
    modalForHome(newValue, oldValue) {
      if (this.watchModal && oldValue && !newValue) {
        this.closeLootBox(); // if prize modal closes, you should close as well!
      }
    },
  },
  created() {
    if (this.checkedNotificationId && this.checkedNotificationReadStatus) {
      this.setDisableDuration();
      this.chestOpened = true;
      this.setRedeemed();
      this.clicked = true;
      this.prizeName = this.notificationRewardName;
      this.result = this.notificationPrizeWon ? 'WIN' : 'LOSE';
      this.showResult = true;
      this.clearData();
    }
  },
  data() {
    return {
      numOfClicks: 0,
      degree: 1800,
      result: '',
      chestOpened: false,
      clicked: false,
      prizeName: '',
      normalDurationPassed: false,
      haveRewardResponse: false,
      disableDuration: false,
      showResult: false,
      watchModal: false,
    };
  },
  methods: {
    ...mapMutations('profile', [
      'setNotificationRewardId',
      'setCheckedNotificationId',
      'setNotificationRewardName',
      'setNotificationPrizeWon',
      'setCheckedNotificationReadStatus',
      'setRedeemedNotification',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapActions('profile', [
      'sendNotificationReward',
    ]),
    open() {
      if (!this.clicked && !this.chestOpened) {
        this.clicked = true;
        const notificationId = this.notificationRewardId ? '' : this.checkedNotificationId;
        this.sendNotificationReward({ reward: this.notificationRewardId, notif: notificationId }).then((response) => {
          this.haveRewardResponse = true;
          this.showResult = true;
          this.result = JSON.parse(response.data.data).result;
          if (this.result) {
            this.prizeName = JSON.parse(response.data.data).prize || this.notificationRewardName;
            this.chestOpened = true;
            this.setRedeemed();
          }
          this.clearData();
        }).catch((error) => {
          // eslint-disable-next-line
          console.log('error while redeem reward: ' + error);
          this.setDisableDuration();
          this.showResult = true;
          this.chestOpened = true;
          this.setRedeemed();
        });
      }
    },
    setDuration() {
      this.normalDurationPassed = true;
      if (this.haveRewardResponse) {
        this.showResult = true;
      }
    },
    setDisableDuration() {
      this.disableDuration = true;
    },
    determineResult() {
      switch (this.result) {
      case 'WIN': return true;
      case 'LOSE':
      default: return false;
      }
    },
    closeLootBox() {
      this.setRedeemed();
      this.$emit('close');
    },
    claimPrize() {
      this.storeModalForHomePage(HowToGetPrize);
      this.watchModal = true;
    },
    setRedeemed() {
      this.setRedeemedNotification(this.checkedNotificationId);
      this.$emit('read', this.checkedNotificationId);
    },
    clearData() {
      this.setNotificationRewardId({ value: '' });
      this.setCheckedNotificationId({ value: '' });
      this.setNotificationRewardName({ value: '' });
      this.setNotificationPrizeWon({ value: false });
      this.setCheckedNotificationReadStatus({ value: false });
    },
  },
  computed: {
    modalForHome() {
      return this.modalForHomePage;
    },
    ...mapState('common', [
      'modalForHomePage',
    ]),
    ...mapState('profile', [
      'checkedNotificationId',
      'checkedNotificationReadStatus',
      'notificationRewardId',
      'notificationRewardName',
      'notificationPrizeWon',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/achievements/LootBox.vue